import { object } from "valibot";
import { requireText } from "../utils/validation/base";
import { MAX_CHARACTERS_SM } from "../constants";
import type ApiKeyId from "../state/ApiKeyId";

export type ApiKey = {
  id: ApiKeyId;
  name: string;
  lastCharacters: string;
  createdOn: Date;
};

export const createApiKeySchema = object({
  name: requireText(MAX_CHARACTERS_SM),
});
